// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Sidebar User Profile Styles */
.sidebar-user-profile {
    margin-left: 10px;
    flex: 1 1;
    min-width: 0; /* Allows flex item to shrink below content size */
    overflow: hidden; /* Prevents content from overflowing */
}

.sidebar-user-profile .user-name {
    font-size: 16px;
    font-weight: 600;
    color: #262A2A;
    margin-bottom: 2px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
}

.sidebar-user-profile .user-email {
    font-size: 14px;
    font-weight: 400;
    color: #6F6F6F;
    margin-bottom: 4px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
}

.sidebar-user-profile .user-roles {
    font-size: 12px;
    font-weight: 500;
    color: #FF6B35; /* Orange color to match the design */
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
}

/* Dark theme support */
[data-sidebar=dark] .sidebar-user-profile .user-name {
    color: #FFF;
}

[data-sidebar=dark] .sidebar-user-profile .user-email {
    color: #e4e4e4;
}

[data-sidebar=blue] .sidebar-user-profile .user-name {
    color: #FFF;
}

[data-sidebar=blue] .sidebar-user-profile .user-email {
    color: #e4e4e4;
}

[data-sidebar=green] .sidebar-user-profile .user-name {
    color: #FFF;
}

[data-sidebar=green] .sidebar-user-profile .user-email {
    color: #e4e4e4;
}

[data-theme=dark] .sidebar-user-profile .user-name {
    color: #FFF;
}

/* No Permission Styles */
.no-permission-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    background: #f9fafb;
  }
  
  .no-permission-card {
    background: #ffffff;
    border-radius: 16px;
    padding: 40px;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.08);
    text-align: center;
    max-width: 400px;
  }
  
  .no-permission-icon {
    width: 80px;
    height: 80px;
    margin-bottom: 20px;
  }
  
  .no-permission-title {
    font-size: 24px;
    font-weight: 600;
    color: #1f2937;
    margin-bottom: 10px;
  }
  
  .no-permission-text {
    font-size: 16px;
    color: #6b7280;
  }
`, "",{"version":3,"sources":["webpack://./src/core/common/sidebar/unauthorized.css"],"names":[],"mappings":"AAAA,gCAAgC;AAChC;IACI,iBAAiB;IACjB,SAAO;IACP,YAAY,EAAE,kDAAkD;IAChE,gBAAgB,EAAE,sCAAsC;AAC5D;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc,EAAE,qCAAqC;IACrD,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,eAAe;AACnB;;AAEA,uBAAuB;AACvB;IACI,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA,yBAAyB;AACzB;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,0CAA0C;IAC1C,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,cAAc;EAChB","sourcesContent":["/* Sidebar User Profile Styles */\n.sidebar-user-profile {\n    margin-left: 10px;\n    flex: 1;\n    min-width: 0; /* Allows flex item to shrink below content size */\n    overflow: hidden; /* Prevents content from overflowing */\n}\n\n.sidebar-user-profile .user-name {\n    font-size: 16px;\n    font-weight: 600;\n    color: #262A2A;\n    margin-bottom: 2px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    max-width: 100%;\n}\n\n.sidebar-user-profile .user-email {\n    font-size: 14px;\n    font-weight: 400;\n    color: #6F6F6F;\n    margin-bottom: 4px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    max-width: 100%;\n}\n\n.sidebar-user-profile .user-roles {\n    font-size: 12px;\n    font-weight: 500;\n    color: #FF6B35; /* Orange color to match the design */\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    max-width: 100%;\n}\n\n/* Dark theme support */\n[data-sidebar=dark] .sidebar-user-profile .user-name {\n    color: #FFF;\n}\n\n[data-sidebar=dark] .sidebar-user-profile .user-email {\n    color: #e4e4e4;\n}\n\n[data-sidebar=blue] .sidebar-user-profile .user-name {\n    color: #FFF;\n}\n\n[data-sidebar=blue] .sidebar-user-profile .user-email {\n    color: #e4e4e4;\n}\n\n[data-sidebar=green] .sidebar-user-profile .user-name {\n    color: #FFF;\n}\n\n[data-sidebar=green] .sidebar-user-profile .user-email {\n    color: #e4e4e4;\n}\n\n[data-theme=dark] .sidebar-user-profile .user-name {\n    color: #FFF;\n}\n\n/* No Permission Styles */\n.no-permission-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 100vh;\n    background: #f9fafb;\n  }\n  \n  .no-permission-card {\n    background: #ffffff;\n    border-radius: 16px;\n    padding: 40px;\n    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.08);\n    text-align: center;\n    max-width: 400px;\n  }\n  \n  .no-permission-icon {\n    width: 80px;\n    height: 80px;\n    margin-bottom: 20px;\n  }\n  \n  .no-permission-title {\n    font-size: 24px;\n    font-weight: 600;\n    color: #1f2937;\n    margin-bottom: 10px;\n  }\n  \n  .no-permission-text {\n    font-size: 16px;\n    color: #6b7280;\n  }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
